export default "__VITE_ASSET__kcZ7OS9O__"